import { z } from 'zod';
import { IsoDateTimeSchema } from './common.js';
const LocalTimeSchema = z
    .string()
    .regex(/^([01]\d|2[0-3]):[0-5]\d$/, 'Expected local time HH:mm');
const DayOfWeekSchema = z.number().int().min(0).max(6);
export const CreateScheduleRequestSchema = z
    .object({
    name: z.string().min(1).max(200).optional(),
    screenId: z.string().min(1).optional(),
    screenGroupId: z.string().min(1).optional(),
    playlistId: z.string().min(1),
    startLocalTime: LocalTimeSchema,
    endLocalTime: LocalTimeSchema,
    daysOfWeek: z.array(DayOfWeekSchema).default([]),
    priority: z.number().int().min(0).max(10_000).optional(),
})
    .superRefine((value, ctx) => {
    const hasScreen = Boolean(value.screenId);
    const hasGroup = Boolean(value.screenGroupId);
    if (hasScreen === hasGroup) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Provide exactly one of screenId or screenGroupId',
            path: hasScreen ? ['screenGroupId'] : ['screenId'],
        });
    }
    if (value.startLocalTime === value.endLocalTime) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'startLocalTime and endLocalTime must differ',
            path: ['endLocalTime'],
        });
    }
});
export const UpdateScheduleRequestSchema = z
    .object({
    name: z.string().min(1).max(200).nullable().optional(),
    playlistId: z.string().min(1).optional(),
    startLocalTime: LocalTimeSchema.optional(),
    endLocalTime: LocalTimeSchema.optional(),
    daysOfWeek: z.array(DayOfWeekSchema).optional(),
    priority: z.number().int().min(0).max(10_000).optional(),
})
    .superRefine((value, ctx) => {
    if (value.startLocalTime !== undefined &&
        value.endLocalTime !== undefined &&
        value.startLocalTime === value.endLocalTime) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'startLocalTime and endLocalTime must differ',
            path: ['endLocalTime'],
        });
    }
});
export const ScheduleSchema = z.object({
    id: z.string().min(1),
    organisationId: z.string().min(1),
    name: z.string().nullable(),
    screenId: z.string().nullable(),
    screenGroupId: z.string().nullable(),
    playlistId: z.string().min(1),
    startLocalTime: LocalTimeSchema,
    endLocalTime: LocalTimeSchema,
    daysOfWeek: z.array(DayOfWeekSchema),
    priority: z.number().int(),
    createdAt: IsoDateTimeSchema,
    updatedAt: IsoDateTimeSchema,
});
export const ResolveScheduleRequestSchema = z.object({
    screenId: z.string().min(1),
    /** ISO-8601 instant to evaluate. Defaults to server now when omitted. */
    now: IsoDateTimeSchema.optional(),
    /**
     * IANA timezone override. When omitted, the screen location timezone is used.
     */
    timeZone: z.string().min(1).max(64).optional(),
});
export const ResolveScheduleResponseSchema = z.object({
    status: z.enum(['override', 'none']),
    scheduleId: z.string().nullable(),
    playlistId: z.string().nullable(),
    timeZone: z.string().min(1),
    evaluatedAt: IsoDateTimeSchema,
});
//# sourceMappingURL=schedule.js.map